import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ButtonV2 } from '@zola/zola-ui';
import { getCookie } from '@zola-helpers/client';

import './PrintChecklistContainer.less';
import PrintChecklistTaskList from '../PrintChecklistTaskList';

import logo from '../../../../../assets/images/logos/zola-logo-horizontal-black.svg';

class PrintChecklistContainer extends Component {
  componentDidMount() {
    const isAutomatedTest = getCookie('automatedTest') || false;
    const { init } = this.props;
    init();
    if (!isAutomatedTest) this.timer = setTimeout(window.print, 2000);
  }

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {
    return (
      <div className="print-checklist__container">
        <div className="print-checklist__container--inner">
          <PrintChecklistTaskList />
          <div className="checklist-print-footer">
            <div>Made with </div><img className="zola-logo-horizontal-black" src={logo} alt="Zola" />
          </div>
        </div>
        <div className="print-checklist__print-button-footer">
          <ButtonV2 className="print-checklist__print-button" onClick={() => window.print()}>Print Checklist</ButtonV2>
        </div>
      </div>
    );
  }
}

PrintChecklistContainer.propTypes = {
  init: PropTypes.func.isRequired,
};

PrintChecklistContainer.defaultProps = {};

export default PrintChecklistContainer;



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/PrintChecklist/PrintChecklistContainer/PrintChecklistContainer.jsx